import { Directive, EmbeddedViewRef, Injector, Input, OnInit, Optional, TemplateRef, ViewContainerRef } from '@angular/core';
import { EditableContentContext, SingleFocusService } from 'components/input/editable-content/editable-content.component';
import 'extensions/deep-copy';

interface DisplayDimensions {
	width: number;
	height: number;
	offsetTop: number;
}


@Directive({ selector: '[editableData]' })
export class EditableContentDirective implements OnInit {
	getDisplayDimensions?: () => DisplayDimensions;

	@Input()
	editableDataFrom!: any;

	editContext: { value: any, getOriginal: Function, editing: boolean } = { value: null, getOriginal: () => { }, editing: false }; // This is the value accessible via "let <variablename>" in the template
	editing = false;

	private sourceObject: any;
	beginEdit(forceSourceObject?: Object) {
		this.sourceObject = forceSourceObject ?? this.editableDataFrom;
		this.editContext.value = Object.deepCopy(this.sourceObject);

		this.editing = this.editContext.editing = true;

		if (this.editView) {
			this.viewContainer.remove(this.viewContainer.indexOf(this.editView));
			this.editView.destroy();
		}

		const context: EditableContentContext = { $implicit: this.editContext, editMode: true, editableContent: this };
		const injector = Injector.create([{ provide: EditableContentContext, useValue: context }]);

		this.viewContainer.insert(
			this.editView = this.viewContainer.createEmbeddedView(this.template, context, { injector: injector }),
			0);
	}

	endEdit() {
		if (this.singleFocus) this.singleFocus.activeComponent = undefined;
		this.editing = this.editContext.editing = false;
	}
	wasChanged(): boolean {
		return !this.compareObject(this.sourceObject, this.editContext.value);
	}

	private compareObject(obj1: any, obj2: any, objectRef?: Object[]): boolean {

		if (obj1 == obj2) return true;
		if (!objectRef) objectRef = [];

		if (objectRef.indexOf(obj1) >= 0) return true;

		if (obj1 instanceof Array) {
			if (obj1.length !== obj2.length) return false;
			for (let i = 0; i < obj1.length; i++) {
				if (!this.compareObject(obj1[i], obj2[i], objectRef)) return false;
			}
			return true;
		}

		if (obj1 instanceof Object) {
			objectRef.push(obj1);
			for (let attribute in obj1) {
				if (obj1.hasOwnProperty(attribute)) {
					if (!obj2.hasOwnProperty(attribute)) return false;
					if (!this.compareObject(obj1[attribute], obj2[attribute], objectRef)) return false;
				}
			}
			return true;
		}
		return false;
	}

	displayView?: EmbeddedViewRef<EditableContentContext>;
	editView?: EmbeddedViewRef<EditableContentContext>;

	constructor(
		private template: TemplateRef<EditableContentContext>,
		private viewContainer: ViewContainerRef,
		@Optional() private singleFocus: SingleFocusService) {
	}

	ngOnInit() {
		const context: EditableContentContext = { $implicit: this.editContext, editMode: false, editableContent: this };
		const injector = Injector.create([{ provide: EditableContentContext, useValue: context }]);
		this.displayView = this.viewContainer.createEmbeddedView(this.template, context, { injector: injector });
		this.editContext.getOriginal = () => { return this.sourceObject; };
	}
}
